import { useWappRoom } from '$logic/wapp-room/react-hook'
import { ActionButton } from '$comp/_app/components/chat/components/footer/components/action-button'
import { nothing } from '$func/utils'
import { t } from '$i18n'

export function WappRoomFooter({ roomId }: { roomId: string }) {
  const { entity: wappRoom, loading } = useWappRoom(roomId)
  return loading || !wappRoom ? null : (
    <ActionButton
      text={wappRoom.muted ? t('chat.unMute') : t('chat.mute')}
      onClick={nothing}
    />
  )
}
